<template>
  <router-view />
</template>

<script>
export default {
  name: 'PurchasingInterestRate'
}
</script>

<style scoped>

</style>
